module.exports = __webpack_public_path__ + "static/img/rank_96.689dab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_96.png
// module id = Ag3O
// module chunks = 0